import { render, staticRenderFns } from "./ProjectAssignmentRow.vue?vue&type=template&id=06b1e073"
import script from "./ProjectAssignmentRow.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentRow.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignmentRow.vue?vue&type=style&index=0&id=06b1e073&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports